import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ClipLoader from "react-spinners/ClipLoader";
import FormHeader from './FormHeader';
import EventDropdown from './EventDropdown';
import InputField from './InputField';
import InputPhoneField from './InputPhoneField';
import ErrorMessage from './ErrorMessage';
import {required, minLength2} from './validations';
import {submitRequestForm, loadCredential, updateCredential} from '../../actions'
import { parsePhoneNumber } from '../../utils';

class ModelForm extends Component {
  constructor() {
    super()
    this.state = {
      showPrimaryBtnLoader: false,
      showSecondaryBtnLoader: false
    }
  }

  componentWillMount() {
    this.props.loadCredential(this.props.params.credentialId)
  }

  submitForm = (values, reload) => {
    const payload = {
      ...values,
      credentialType: "model",
      phoneNumber: parsePhoneNumber(values.phoneNumber),
    };

    if (this.props.params.credentialId) {
      return this.props.updateCredential(this.props.params.credentialId, payload, reload)
    } else {
      return this.props.submitRequestForm(payload, reload)
    }
  };

  submitFormAndRedirect = async (values) => {
    this.setState({ showPrimaryBtnLoader: true })
    await this.submitForm(values, false)
    this.setState({ showPrimaryBtnLoader: false })
  };

  submitFormAndReload = async (values) => {
    this.setState({ showSecondaryBtnLoader: true })
    await this.submitForm(values, true)
    this.setState({ showSecondaryBtnLoader: false })
  };

  render() {
    const { handleSubmit, error, params } = this.props;
    const isEditing = !!params.credentialId
    const headerTitle = `${isEditing ? 'Edit' : 'New'} Request`
    const panelTitle = `${isEditing ? 'Edit' : 'Add New'} Model Wristband`
    const submitBtnText = `${isEditing ? 'Update' : 'Send'}`

    return (
      <div className="container">
        <FormHeader headerTitle={headerTitle} />
        <form onSubmit={handleSubmit(this.submitFormAndRedirect)}>
          <div className="panel panel-card panel-card-lg">
            <div className="panel-heading card-brand card-model text-center">
              <h3 className="panel-title">{panelTitle}</h3>
            </div>

            <div className="panel-body">
              {error && <ErrorMessage message={error.error} />}
              <Field label="Event" name="round" component={EventDropdown} validateFields={[ required ]} />
              <Field label="First Name" name="firstName" component={InputField} validate={[ required, minLength2 ]}/>
              <Field label="Last Name" name="lastName" component={InputField} validate={[ required, minLength2 ]} />
              <Field label="Phone Number" name="phoneNumber" component={InputPhoneField} validate={[ required ]} />
            </div>
          </div>

          <div className="form-group">
            <button name="send" type="submit" className="btn btn-primary btn-block btn-lg">
              { (!this.state.showPrimaryBtnLoader || error) && <span>{submitBtnText}</span> }
              <ClipLoader
                color={'#ffffff'}
                loading={this.state.showPrimaryBtnLoader && !error}
                size={20}
                aria-label="Loading Spinner"
              />
            </button>
            <button name="sendAddAnother" onClick={handleSubmit(this.submitFormAndReload)} type="button" className="btn btn-primary-outline btn-block btn-lg">
              { (!this.state.showSecondaryBtnLoader || error) && <span>{submitBtnText} and add another</span> }
              <ClipLoader
                color={'#ffffff'}
                loading={this.state.showSecondaryBtnLoader && !error}
                size={20}
                aria-label="Loading Spinner"
              />
            </button>
          </div>
        </form>
      </div>
    )
  }
}

const modelFormReduxForm = reduxForm({
  form: 'modelForm',
  enableReinitialize: true,
})(ModelForm);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({submitRequestForm, loadCredential, updateCredential}, dispatch);
}

const modelFormConnect = connect(
  state => ({
    initialValues: state.credentials.credentialToLoad || {round: state.eventDetails.eventId}
  }), mapDispatchToProps)(modelFormReduxForm);

export default modelFormConnect;



// WEBPACK FOOTER //
// ./src/components/RequestForm/ModelForm.js